import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import css from '@src/styles/components/form/range.scss';
import style from '@src/js/Style';

export default class Range extends React.Component {

    constructor(props) {

        super(props);

        this.nodes = {
            input: null,
        };
    }

    static get propTypes() {

        return {
            min: PropTypes.number,
            max: PropTypes.number,
            value: PropTypes.number,
            onChange: PropTypes.func,
        };
    }

    render() {

        return <Input
            ref={ (node) => { this.nodes.input = node; } }
            defaultClassName={ style('form-range', css) }
            type='range'
            min={ this.props.min }
            max={ this.props.max }
            value={ this.props.value }
            style={ this.getStylesVars() }
            debounceTimeout={ 0 }
            onChange={ (e) => this.changeEvent(e) }
            { ...this.unusedProps } />;
    }

    getValue() {

        return this.nodes.input.value;
    }

    componentDidUpdate() {

        if (this.nodes?.input?.nodes?.input != undefined)
            this.nodes.input.nodes.input.value = this.props.value;
    }

    getStylesVars() {

        return {
            '--min': this.props.min,
            '--max': this.props.max,
            '--value': this.props.value,
        };
    }

    changeEvent(e) {

        this.nodes.input.nodes.input.style.setProperty('--value', e.target.value);

        if (this.props.onChange != undefined)
            this.props.onChange(e);
    }

    /** private */ get unusedProps() {
        
        const usedKeys = Object.keys(Range.propTypes);
        return Object.fromEntries(Object.entries(this.props).map(([key, value]) => {
            
            if (!usedKeys.includes(key))
                return [key, value];

        }).filter((value) => value !== undefined));
    }
}